import TicketsConfigURL from "@adapters/infrastructures/urlConfig/TicketPortal/tickets";
import { ticketsDataMapper } from "@domains/features/TicketPortal/mapper/ticketsData";
class TicketsRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getTicketsData() {
        const url = new URL(TicketsConfigURL.getTicketsDataUrl);
        const ticketsData = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        //const ticketsData = JSON.parse(dummyTicketData)
        return ticketsDataMapper(ticketsData.data);
    }
    async createTicketData(req) {
        const url = new URL(TicketsConfigURL.createTicketUrl);
        const ticketsData = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req
        });
        return ticketsData.data;
    }
}
export default TicketsRepository;
